import { ENTITY_PROCEDURE_SECTION_ID } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure.const';

export function scrollToEntityProcedureSection(): void {
  document.getElementById(ENTITY_PROCEDURE_SECTION_ID)?.scrollIntoView({ behavior: 'smooth' });
}
